import { collection, onSnapshot, query } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebase/client";

const STALE_MS = 60_000;

export function useViewerCount(broadcastId: string | null): number {
	const [count, setCount] = useState(0);

	useEffect(() => {
		if (!broadcastId) return;

		const q = query(collection(db, "broadcasts", broadcastId, "viewers"));

		return onSnapshot(q, (snapshot) => {
			const now = Date.now();
			const active = snapshot.docs.filter((d) => {
				const lastSeen = d.data().lastSeen?.toMillis?.() ?? 0;
				return now - lastSeen < STALE_MS;
			});
			setCount(active.length);
		});
	}, [broadcastId]);

	return count;
}
